import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';

import LocalListItem from './LocalListItem';

export default ({ locals, setSelectedLocalID, className }) => {
  const localsToShow = () => locals.filter((local) => local.abierto);

  const counterResults = () => {
    const results = localsToShow().length;

    return (
      <CounterResults>
        {results}
        {' '}
        {results === 1 ? 'resultado' : 'resultados'}
      </CounterResults>
    );
  };

  const handleClick = (localID) => setSelectedLocalID(localID);

  return (
    <Container className={className}>
      <Header>
        {counterResults()}
      </Header>

      <Locals>
        {localsToShow()
          .map((local) => (
            <LocalListItem
              local={local}
              key={local.local}
              onClick={() => handleClick(local.local)}
            />
          ))}
      </Locals>

    </Container>
  );
};

const Container = styled.div`
  box-sizing: border-box;
  background-color: #F7F7F7;
  border-left: 1px solid #ccc;

  ${tw`
    pt-20 pb-2 flex flex-col h-full
  `};

  @media (min-width: 768px) {
    ${tw`
      pt-4
    `}
  }
`;

const Header = styled.div`
`;

const CounterResults = styled.div`
  ${tw`
    mt-2 mb-4 text-xs block mx-auto text-center
  `}
`;

const Locals = styled.div`
  ${tw`
    flex-1 overflow-auto px-4
  `}

  @media (min-width: 768px) {
    ${tw`
      px-10
    `}
  }
`;
